import { jsx as _jsx } from "react/jsx-runtime";
import { useMessageBus } from "@jti/fe-message-bus";
import { QuickLinks, QuickLinksGroup } from "@jti/ui/components/QuickLinks";
export const FaqList = ({ title, listItems, listClickEvent }) => {
    const messageBus = useMessageBus();
    const handleClick = () => {
        messageBus.publish("tracking.event", {
            payload: {
                event_name: listClickEvent,
            },
        });
    };
    const links = listItems.map((item) => {
        const { title, path } = item;
        const target = "tabBehavior" in item && item.tabBehavior === "sameTab" ? "_self" : "_blank";
        return {
            href: path,
            label: title,
            target,
        };
    });
    return (_jsx(QuickLinks, { onClick: handleClick, children: _jsx(QuickLinksGroup, { title: title, categories: [{ links }] }) }));
};
//# sourceMappingURL=FaqList.js.map